import type { FieldProp } from 'react-typed-form';

import { ErrorList } from '../../../components';
import TiptapEditor from './TiptapEditor';

type Props = Readonly<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: FieldProp<any>;
  onPasteFiles?: (files: File[]) => boolean;
  placeholder?: string;
}>;

export default function FieldWriter({
  field,
  onPasteFiles,
  placeholder,
}: Props) {
  return (
    <>
      <TiptapEditor
        value={field.value || ''}
        onChange={field.handleValueChange}
        onPasteFiles={onPasteFiles}
        placeholder={placeholder}
      />
      <ErrorList errors={field.lastErrorList} />
    </>
  );
}
